const MY_PROJECT_LIVE_PRICE_ID = "price_1SonkALs3VmGBJkcpu1d3u2W";
const MY_PROJECT_TEST_PRICE_ID = "price_1Ryza9Ls3VmGBJkchlL7WZkQ";
const isDevelopmentBuild = process.env.NODE_ENV === "development";

export const pricingPlans = [
    {
      id: 1,
      name: "my_project_plan",
      monthlyPrice: 1.99, // One-time promotional fee
      annualPrice: 1.99, // Same price for both (one-time)
      stripePriceId: isDevelopmentBuild ? MY_PROJECT_TEST_PRICE_ID : MY_PROJECT_LIVE_PRICE_ID,
      stripePriceIdAnnual: isDevelopmentBuild ? MY_PROJECT_TEST_PRICE_ID : MY_PROJECT_LIVE_PRICE_ID,
      projectLimit: 0, // Base is 0, projects are added via extraProjectPurchased
      includedGenerations: 2,
      duration: "one_time",
      isOneTime: true, // Flag to indicate this is a one-time payment
      features: [
        "1 project",
        "App access for 30 days maximum",
        "Full AI design assistance",
        "Email support",
        "No ads"
      ],
      popular: true
    },
    {
      id: 2,
      name: "standard_plan",
      monthlyPrice: 4.99,
      annualPrice: 49.90, // Annual: 10 months price (2 months free)
      stripePriceId: "price_1SonkQLs3VmGBJkc0KkSUBXV", // Standard monthly price ID
      stripePriceIdAnnual: "price_1SooZzLs3VmGBJkcp4azIrc3", // Standard annual price ID
      projectLimit: 5,
      includedGenerations: 10,
      duration: "monthly",
      features: [
        "7 days trial period",
        "Up to 5 projects",
        "Full AI design assistance",
        "Email support",
        "No ads",
        "No watermark"
      ],
      popular: false
    },
    {
      id: 3,
      name: "pro_plan",
      monthlyPrice: 19.99,
      annualPrice: 199.90, // Annual: 10 months price (2 months free)
      stripePriceId: "price_1SonkLLs3VmGBJkcFWrBzFR3", // ✅ LIVE: facadewebapp monthly $19.99
      stripePriceIdAnnual: "price_1SoocmLs3VmGBJkcrQFw6F4g", // ✅ LIVE: $199.90/year USD (2 months free)
      projectLimit: 25,
      includedGenerations: 25,
      duration: "monthly",
      features: [
        "Up to 25 projects",
        "Full AI design assistance",
        "Priority support",
        "No ads",
        "No watermark"
      ],
      popular: false
    }
  ];

  export default pricingPlans;
